import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/index.css';
import notify_util from './mixin/notifyjs'
import util from './mixin/utiljs'

import Vuelidate from 'vuelidate'
import "./assets/scss/b-pager.css";
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import moment from 'moment-timezone'
import wysiwyg from "vue-wysiwyg";
import "vue-wysiwyg/dist/vueWysiwyg.css";
import Multiselect from 'vue-multiselect'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';


moment.tz.setDefault('Asia/Tokyo')
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
Vue.config.productionTip = false
Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.use(VueToast);
Vue.use(Vuelidate)
Vue.mixin(notify_util)
Vue.mixin(util)
Vue.use(VueSweetalert2);
Vue.use(wysiwyg, {});
Vue.component('multiselect', Multiselect)

new Vue({
  router,
  store,
  icons,
  render: h => h(App)
}).$mount('#app')
